/**
 * 接口地址
 * @type {string}
 */
let api_base = `https://wfj.wolkm.cn/admproj/`
if (process.env.NODE_ENV == 'development') {
    api_base = `/admproj/`
}

export const API_BASE_URL = api_base;

/** 皋翔公证网关（浏览器可直传文件，不经 admproj） */
export const DATA_NOTARY_GATEWAY = 'https://api.wolkm.cn/?s=/ApiDataNotaryOpen'
export const DATA_NOTARY_UPLOAD_URL = DATA_NOTARY_GATEWAY + '/upload'
0